import { StaticProperties } from './parkopedia';
import { types } from 'mobx-state-tree';
import { Point } from '../poi';
import { MobxParkopediaStore } from './parkopedia';

export const Parking = types
  .model({
    selectedSpot: types.optional(types.maybeNull(StaticProperties, null)),
    parkopedia: types.optional(types.maybeNull(MobxParkopediaStore, null)),
    currentPosition: types.optional(types.maybeNull(Point, null)),
  })
  .actions((self) => ({
    clear: () => (self.selectedSpot = null),
    setInfo: (info) => (self.selectedSpot = JSON.parse(JSON.stringify(info))),
    setPosition: (pos) => (self.currentPosition = pos),
  }));

export const initialState = {
  parking: {
    MobxParkopediaStore: MobxParkopediaStore.create(),
    selectedSpot: null,
  },
};
